module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('dl', [_c('dt', [_c('i', {
    staticClass: "iconfont icon-phone"
  }), _vm._v(" 客服电话")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "tel:400-060-6050"
    }
  }, [_vm._v("400-060-6050")])])]), _vm._v(" "), _c('dl', [_c('dt', [_c('i', {
    staticClass: "iconfont icon-email"
  }), _vm._v(" 客服邮箱")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "mailto:service@orvibo.com"
    }
  }, [_vm._v("service@orvibo.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ea732da"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ContactUs/Index.vue
// module id = 900
// module chunks = 1